

























































































































































































































































































import { Component, Vue } from "vue-property-decorator";
import { ResultImage, Result, VisitorCenter } from "../data/TypesData";
import axios from "axios";
import Divider from "../components/Divider.vue";
import FlatButton from "../components/FlatButton.vue";

type Request = {
  req: string;
  resp: any;
  limit: number;
};

@Component({
  components: {
    Divider,
    FlatButton
  }
})
export default class Park extends Vue {
  baseURL = process.env.VUE_APP_BASE_URL;
  apiKey = process.env.VUE_APP_API_KEY;

  parkCode: any = "";

  parkData: Array<Result> = [];
  imageGallery: Array<ResultImage> = [];

  visitorcenters: Array<VisitorCenter> = [];
  campgrounds: Array<any> = [];
  newsreleases: Array<any> = [];
  events: Array<any> = [];
  alerts: Array<any> = [];
  articles: Array<any> = [];
  lessonplans: Array<any> = [];
  people: Array<any> = [];
  places: Array<any> = [];

  requests: Array<Request> = [
    { req: "visitorcenters", resp: this.visitorcenters, limit: 50 },
    { req: "campgrounds", resp: this.campgrounds, limit: 7 },
    { req: "newsreleases", resp: this.newsreleases, limit: 7 },
    { req: "events", resp: this.events, limit: 7 },
    { req: "alerts", resp: this.alerts, limit: 50 },
    { req: "articles", resp: this.articles, limit: 7 },
    { req: "lessonplans", resp: this.lessonplans, limit: 7 },
    { req: "people", resp: this.people, limit: 7 },
    { req: "places", resp: this.places, limit: 7 }
  ];

  bgImageURL: string = "../assets/logo.png";

  loaded = false;

  /**
   * Gets basic park information and initializes main image as well as the
   * image gallery.
   */
  getParkData() {
    this.parkCode = this.$route.query.code;
    const request =
      this.baseURL +
      "parks?parkCode=" +
      this.parkCode +
      "&fields=images" +
      this.apiKey;
    axios
      .get(request)
      .then(
        response => (
          (this.loaded = true),
          (this.parkData = response.data.data),
          (this.imageGallery = response.data.data[0].images),
          (this.bgImageURL = response.data.data[0].images[0].url)
        )
      );
  }

  /**
   * Returns the resp "value" given a req "key" and a Request array.
   */
  getResp(reqKey: string, requests: Array<Request>) {
    return requests.find(request => request.req === reqKey)!.resp;
  }

  /**
   * Returns the Request object given a req "key" and Request array.
   */
  getRequestRecord(reqKey: string, requests: Array<Request>) {
    return requests.find(request => request.req === reqKey)!;
  }

  /**
   * Assigns class variables to their corresponding responses.
   */
  setResponse() {
    this.visitorcenters = this.getResp("visitorcenters", this.requests);
    this.campgrounds = this.getResp("campgrounds", this.requests);
    this.newsreleases = this.getResp("newsreleases", this.requests);
    this.events = this.getResp("events", this.requests);
    this.alerts = this.getResp("alerts", this.requests);
    this.articles = this.getResp("articles", this.requests);
    this.lessonplans = this.getResp("lessonplans", this.requests);
    this.people = this.getResp("people", this.requests);
    this.places = this.getResp("places", this.requests);
  }

  /**
   * Requests more of a given request by increasing the request limit by 3.
   * @example: seeMore('articles') will make a request for more 3 more articles
   * than the current limit.
   */
  seeMore(req: string) {
    const requestIndex = this.requests.indexOf(
      this.getRequestRecord(req, this.requests)
    );
    this.requests[requestIndex].limit += 3;
    const request = this.requests[requestIndex];
    axios
      .get(
        this.baseURL +
          request.req +
          "?parkCode=" +
          this.parkCode +
          "&limit=" +
          request.limit +
          this.apiKey
      )
      .then(
        response => ((request.resp = response.data.data), this.setResponse())
      );
  }

  /**
   * Makes a API request for each of the Requests in this.requests.
   */
  getRequests() {
    this.requests.map(request =>
      axios
        .get(
          this.baseURL +
            request.req +
            "?parkCode=" +
            this.parkCode +
            "&limit=" +
            request.limit +
            this.apiKey
        )
        .then(
          response => ((request.resp = response.data.data), this.setResponse())
        )
    );
  }

  /**
   * Initializes requests on page load.
   */
  mounted() {
    this.getParkData();
    this.getRequests();
  }
}
